import { getCookie } from '@/utils/cookies'
import { getDomainZone } from '@/utils/domains'

export const CLIENT_ID_KEY = 'utmClientId'
export const PROMOCODE_KEY = 'promocode'

function getCookieDomainAttribute(): string {
  if (typeof window === 'undefined') {
    return ''
  }

  const zone = getDomainZone(window.location.hostname)

  if (zone === '' || window.location.hostname === zone) {
    return ''
  }

  return `; domain=${zone}`
}

function deleteMarketingCookie(name: string) {
  document.cookie = `${name}=; max-age=0; path=/; samesite=lax${getCookieDomainAttribute()}`
}

function getMarketingCookie(name: string): string | null {
  const value = getCookie(name)

  return value != null && value !== '' ? value : null
}

export const marketingStorage = {
  getClientId(): string | null {
    if (typeof window == 'undefined') {
      return null
    }

    return getMarketingCookie(CLIENT_ID_KEY)
  },

  clearClientId() {
    if (typeof window == 'undefined') {
      return
    }

    deleteMarketingCookie(CLIENT_ID_KEY)
  },

  getPromocode(): string | null {
    if (typeof window == 'undefined') {
      return null
    }

    return getMarketingCookie(PROMOCODE_KEY)
  },

  clearPromocode() {
    if (typeof window == 'undefined') {
      return
    }

    deleteMarketingCookie(PROMOCODE_KEY)
  },
}
